import { CommandIcon, SearchIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Kbd } from '@/components/ui/kbd';
import useOperatingSystem from '@/hooks/useOperatingSystem';

import { useCommandPaletteContext } from './CommandPaletteProvider';

export const CommandPaletteTrigger = () => {
  const { openFromTrigger } = useCommandPaletteContext();
  const { t } = useTranslation();
  const { isMacOS } = useOperatingSystem();

  const tooltipContent = (
    <>
      {t('command_palette.search')}
      <Kbd>{isMacOS() ? <CommandIcon size={10} /> : 'Ctrl'}</Kbd>
      <Kbd>K</Kbd>
    </>
  );

  return (
    <InfoTooltip
      content={tooltipContent}
      size="auto"
      className="flex items-center gap-1.5"
      delayDuration={200}
    >
      <span>
        <button
          type="button"
          aria-label={t('command_palette.placeholder')}
          className="flex h-8 w-8 items-center justify-center rounded text-sm font-medium text-navigation-element hover:bg-white/16 wide:w-auto wide:min-w-32 wide:justify-start wide:gap-1.5 wide:rounded-md wide:bg-white/5 wide:px-2.5"
          onClick={openFromTrigger}
        >
          <SearchIcon size={16} className="shrink-0" />
          <span className="hidden text-left opacity-80 wide:inline">
            {t('command_palette.search')}
          </span>
        </button>
      </span>
    </InfoTooltip>
  );
};
